import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Download, Gift, Lock } from 'lucide-react';
export function OpeningLead() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) {
      cta.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleBuy = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Plan B Migratorio',
        content_type: 'product',
        value: 6.97,
        currency: 'USD'
      });
    }
    window.location.href = 'https://simplementemejor.com/cart/51755419697432:1';
  };
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="pt-12 pb-8 md:pb-16 px-4 md:px-6 w-full relative bg-[var(--bg-deep)] overflow-hidden" data-id="element-259">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[60vh] pointer-events-none z-0" style={{
      background: 'radial-gradient(ellipse 60% 80% at 50% 0%, rgba(212,136,58,0.08) 0%, transparent 70%)'
    }} data-id="element-260" />

      <motion.div variants={container} initial="hidden" animate="show" className="max-w-[720px] mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-261">
        {/* Label */}
        <motion.div variants={item} data-id="element-262">
          <p className="text-[var(--accent)] font-bold tracking-widest uppercase text-xs md:text-sm mb-1.5 md:mb-3" data-id="element-263">
            🛫 Guía de Relocalización Legal
          </p>
        </motion.div>

        {/* Headline */}
        <motion.div variants={item} data-id="element-264">
          <h1 className="md:text-5xl lg:text-6xl font-serif font-bold text-[var(--text-heading)] mb-4 md:mb-6 text-[32px] leading-tight" data-id="element-265">
            DETÉN LA "CAMINADORA DE DEUDAS" EN USA Y RECUPERA TU DIGNIDAD EN
            OTRO PAÍS EN SOLO 14 DÍAS
          </h1>
        </motion.div>

        {/* Subtitle */}
        <motion.div variants={item} data-id="element-266">
          <p className="text-base md:text-xl text-[var(--text-primary)] leading-relaxed max-w-2xl mx-auto mb-6 md:mb-10 font-light" data-id="element-267">
            El sistema logístico paso a paso para trasladar tus ahorros de forma
            segura, obtener residencia legal y vivir como dueño gastando 1/3 de
            lo que hoy pagas de renta.
          </p>
        </motion.div>

        {/* Book Image (3D Book Mockup) */}
        <motion.div variants={item} className="mb-6 md:mb-10 relative" style={{
        perspective: '800px'
      }} data-id="element-268">
          {/* Soft gold glow underneath the book */}
          <div className="absolute bottom-[-12px] left-1/2 -translate-x-1/2 w-[75%] h-10 pointer-events-none z-0" style={{
          background: 'radial-gradient(ellipse at center, rgba(212,136,58,0.35) 0%, rgba(212,136,58,0.1) 50%, transparent 80%)',
          filter: 'blur(18px)'
        }} data-id="element-269" />

          {/* The 3D book itself */}
          <motion.div animate={{
          y: [0, -10, 0],
          rotateY: [-2, 2, -2]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          transformStyle: 'preserve-3d'
        }} className="relative z-10" data-id="element-270">
            <img src="https://cdn.magicpatterns.com/uploads/tfS3vCDpgVvpPUPiKrgPFg/cover.png" alt="Plan B Migratorio" className="w-40 md:w-64 mx-auto drop-shadow-[0_20px_50px_rgba(212,136,58,0.3)] rounded-lg" data-id="element-271" />
          </motion.div>
        </motion.div>

        {/* CTA Area */}
        <motion.div variants={item} className="w-full sm:w-auto mb-3 md:mb-4 flex flex-col items-center" data-id="element-272">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto px-6 md:px-10 py-4 md:py-5 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#110608] font-extrabold text-sm md:text-lg rounded-xl shadow-[0_8px_25px_rgba(212,136,58,0.3)] flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-273">
            <Lock className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" data-id="element-274" />
            <span className="uppercase tracking-wide" data-id="element-275">
              SÍ, QUIERO MI SALIDA SEGURA POR $6.99
            </span>
          </motion.button>
          <p className="text-[var(--text-muted)] text-xs md:text-sm mt-3 font-medium" data-id="element-276">
            Acceso inmediato en PDF
          </p>
        </motion.div>

        {/* Social Proof */}
        <motion.div variants={item} className="mb-3 md:mb-6 mt-4" data-id="element-277">
          <div className="flex flex-col items-center gap-1.5" data-id="element-278">
            <div className="flex items-center gap-1" data-id="element-279">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[var(--accent)] text-[var(--accent)]" data-id="element-280" />)}
            </div>
            <p className="text-sm text-[var(--text-primary)] font-medium" data-id="element-281">
              +5,000 personas ya activaron su Plan B
            </p>
          </div>
        </motion.div>

        {/* Trust Badges */}
        <motion.div variants={item} data-id="element-282">
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 text-xs text-[var(--text-muted)]" data-id="element-283">
            <span className="flex items-center gap-1.5" data-id="element-284">
              <Download className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-285" />
              Descarga digital instantánea
            </span>
            <span className="hidden md:inline opacity-30" data-id="element-286">·</span>
            <span className="flex items-center gap-1.5" data-id="element-287">
              <ShieldCheck className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-288" />
              Garantía 7 días
            </span>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}